<template>
  <div>
    <nurse-table
      :canDelete="true"
      viewRoute="AdminNurseDetails"
      :canCreate="true"
      viewDetailRoute="SubAdminNurseDetail"
      createRoute="AdminNurseCreate"
    />
  </div>
</template>

<script>
import nurseTable from '../../components/nurses/nurseTable.vue';

export default {
  components: {
    nurseTable,
  },
  data: () => ({}),
};
</script>
